"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.752 1.752 19.8307 19.8525-1.3979 1.3967-1.166-1.1653a3.008 3.008 0 0 1-1.8539-1.8528l-1.1648-1.1641v1.1811h-15v-16h.1721l-.8377-.8373 1.4148-1.4135.0028.0027zM3.0002 6h.1733l4.0024 4.0001H6.0001v8h-3v-12zm5 6.0001h1.177l.823.8226v5.1774h-2v-6zm4 6v-3.1787l2 1.9988v1.1799h-2z"
  }), _react.default.createElement("path", {
    d: "m6.8245 4 1.9978 2H19v7.1708a3.0095 3.0095 0 0 0-1.6306 1.3859L19 16.1892v-.1891c0-.5523.4477-1 1-1s1 .4477 1 1v2.1913l1.8234 1.8253A2.9951 2.9951 0 0 0 23 19.0001v-3c0-1.3063-.8348-2.4175-2-2.8293V4.0001H6.8245z"
  }), _react.default.createElement("path", {
    d: "M16.0001 13.1858v-3.1857h-3.1822l3.1822 3.1857z"
  })];
};

exports.default = _default;